/**
 * Centralized API configuration for SalesWall.ai
 * Uses relative paths for production compatibility with Nginx reverse proxy
 */

const API_BASE_URL: string = process.env.REACT_APP_BACKEND_URL ?? '';

export const getApiUrl = (endpoint: string): string => {
  const normalizedEndpoint = endpoint.startsWith('/api') ? endpoint : `/api${endpoint}`;
  return `${API_BASE_URL}${normalizedEndpoint}`;
};

export const apiRequest = async (
  endpoint: string,
  options: RequestInit = {}
): Promise<Response> => {
  const token = localStorage.getItem('token');
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  if (token) {
    (headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
  }
  return fetch(getApiUrl(endpoint), {
    ...options,
    headers,
  });
};

export const API_URL = API_BASE_URL;
